// Constants
export const TABLE_SCROLL_HEIGHT = 'calc(100vh - 277px)';
export const MIN_SEARCH_LENGTH = 3;
export const DRAWER_WIDTH = '520px';

export const EMPTY_STATE_MESSAGES = {
  SEARCH_INSTRUCTION:
    'Enter at least three characters to search the pest list.',
  NO_RESULTS: 'No pests found matching your search criteria.'
};

export const PLACEHOLDER_TEXT =
  'Enter at least three characters to search pests';

const BUTTON_TEXTS = {
  CANCEL: 'Cancel',
  CLEAR: 'Clear',
  SAVE_PESTS: 'Save Pests'
};

export default BUTTON_TEXTS;
